<template>
  <div>
    <div class="sm:hidden">
      <label for="tabs" class="sr-only">Select a tab</label>
      <select id="tabs" name="tabs" class="form-select" @change="changeRoute">
        <option v-for="tab in tabs" :key="tab.name" :value="JSON.stringify(tab.route)" :selected="tab.route.name === $route.name">
          {{ tab.name }}
        </option>
      </select>
    </div>
    <div class="hidden sm:block">
      <div class="border-b border-gray-200">
        <nav class="flex -mb-px space-x-4" aria-label="Tabs">
          <router-link 
            v-for="tab in tabs" 
            :key="tab.name" 
            :to="tab.route" 
            :class="[tab.route.name === $route.name ? 'border-indigo-500 text-gray-700' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'hover:no-underline whitespace-nowrap py-3.5 border-b-2 font-medium']" 
            :aria-current="tab.route.name === $route.name ? 'page' : undefined">
            {{ tab.name }}
          </router-link>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavTabs',

  props: {
    tabs: {
      type: Array
    }
  },

  methods: {
    changeRoute (event) {
      console.log(JSON.parse(event.target.value))
      const tab = this.tabs.find(t => t.route.name === JSON.parse(event.target.value).name)
      this.$router.push(tab.route)
    }
  }
}
</script>